"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  addRef: function addRef() {},
  contextData: null,
  data: null,
  disabled: false,
  errors: {},
  hasError: false,
  hasRequiredData: false,
  hasChanges: false,
  setContext: function setContext() {},
  onChange: function onChange() {},
  onReset: function onReset() {},
  onSubmit: function onSubmit() {},
  onValidate: function onValidate() {},
  refs: function refs() {},
  removeRef: function removeRef() {}
});

exports.default = _default;